fragment ImageFull on Image {
  path
  title
  type
  size
}
